import theme from '@vromo/ui/components/theme';
import { css } from 'emotion';
import { darken } from 'polished';

export const pageContainer = css`
    flex-direction: row;

    @media (max-width: 1000px) {
        flex-direction: column;
    }
`;

export const pageContainerStyle = {
    display: 'flex',
    flex: 1,
    position: 'relative',
    minHeight: 0 // Load bearing, fixes chrome bug https://bugs.chromium.org/p/chromium/issues/detail?id=927066
};

export const getNewJobButtonStyle = (expanded: boolean) => css`
    background-color: ${theme.primary};
    width: 40px;
    height: 40px;
    border-radius: 100%;
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: ${expanded ? 'translate(-50%, -100%)' : 'translate(-50%,0)'};
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: background-color 200ms ease-in-out;

    &:hover {
        background-color: ${darken(0.05, theme.primary)};
    }
`;

export const JOB_PANEL_WIDTH = 420;

export const getJobTabStyle = (
    expanded: boolean,
    searchString?: string,
    isDetailedView?: boolean
) => css`
    position: absolute;
    top: ${expanded ? '0' : '20px'};
    right: ${expanded ? '0' : '20px'};
    width: ${expanded ? '100%' : `${JOB_PANEL_WIDTH}px`};
    height: ${expanded ? '100%' : !searchString && !isDetailedView ? 'auto' : '85vh'};
    display: flex;
    background-color: white;
    border-radius: ${expanded ? '0' : '8px'};
    z-index: ${expanded ? '100' : 'auto'};

    @media (max-width: 1000px) {
        position: relative;
        width: 100%;
        right: auto;
        top: auto;
        border-radius: 0;
        max-width: 100%;
    }
`;

export const getExpandJobsStyle = (expanded: boolean) => css`
    position: absolute;
    background-color: ${theme.primary};
    width: 20px;
    height: 20px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: ${expanded ? 'none' : 'translate(-50%, -50%)'};
    color: white;
    z-index: 3;
    cursor: pointer;

    @media (max-width: 500px) {
        display: none;
    }
`;
